interface BadgeProps {
	children: React.ReactNode;
	variant?: "default" | "green" | "amber" | "red" | "blue" | "purple" | "gray";
	size?: "sm" | "md";
}

const variantClasses: Record<string, string> = {
	default: "bg-bg-tertiary text-text-secondary",
	green: "bg-accent-primary/15 text-accent-primary",
	amber: "bg-accent-secondary/15 text-accent-secondary",
	red: "bg-accent-danger/15 text-accent-danger",
	blue: "bg-accent-info/15 text-accent-info",
	purple: "bg-purple-500/15 text-purple-400",
	gray: "bg-bg-tertiary text-text-muted",
};

const sizeClasses: Record<string, string> = {
	sm: "text-xs px-1.5 py-0.5",
	md: "text-sm px-2 py-0.5",
};

export function Badge({ children, variant = "default", size = "sm" }: BadgeProps) {
	return (
		<span
			className={`inline-flex items-center rounded font-medium ${variantClasses[variant]} ${sizeClasses[size]}`}
		>
			{children}
		</span>
	);
}
